import React, { useState } from "react";
import { IMenuOption } from "./Dropdown";
import { getKnowledgeHubUrl } from "../utils/headerUtils";

interface IProps {
  options: { label: string; url?: string; options?: IMenuOption[] }[];
  onClose?: () => void;
}

const MobileMenu: React.FC<IProps> = ({ options, onClose }) => {
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  const handleToggle = (label: string) => {
    setOpenMenu((prev) => (prev === label ? null : label));
  };

  const handleMenuOptionClick = (option: IMenuOption) => {
    if (option.onClick) {
      option.onClick();
    } else if ((option as any).url) {
      if (option?.label?.toLowerCase() === "platform guide") {
        const currentUrl =
          typeof window !== "undefined" ? window.location.href : "";
        window.location.href = getKnowledgeHubUrl(currentUrl);
      } else {
        window.location.href = (option as any).url;
      }
    }
    onClose?.();
  };

  return (
    <>
      {/* Menu Items */}
      {options.map((item, index) => {
        const hasChildren = item.options && item.options.length > 0;

        return (
          <div
            key={`mobile_menu_${index}`}
            className="rec_header_ls_mobile_item"
          >
            <button
              className={`rec_header_ls_mobile_button ${
                openMenu === item.label ? "subMenuOpen" : ""
              }`}
              onClick={() => {
                if (hasChildren) {
                  handleToggle(item.label);
                } else if (item.url) {
                  window.location.href = item.url;
                  onClose?.();
                }
              }}
            >
              {item.label}
              {hasChildren && (
                <div
                  className={`RECHeaderSprite icons ${
                    openMenu === item.label ? "up_arrow" : "dwn_arrow"
                  }`}
                />
              )}
            </button>

            {hasChildren && openMenu === item.label && (
              <div className="rec_header_ls_mobile_subitems">
                {item.options!.map((opt, subIndex) => (
                  <div
                    key={`mobile_sub_${subIndex}`}
                    className="rec_header_ls_mobile_subitem"
                    onClick={() => handleMenuOptionClick(opt)}
                  >
                    {opt.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default MobileMenu;
